<template>
  <div color="#fff">
    <v-tab :ripple="false" class="font-weight-bold" min-width="96" text>
      <v-menu
        v-model="menu"
        :close-on-content-click="true"
        :nudge-width="200"
        offset-x
        offset-y
        @input="refreshBalance"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-avatar dark v-bind="attrs" v-on="on">
            <div v-if="getActive">
              <v-icon color="primary" size="30">mdi-account-check</v-icon>
            </div>
            <div v-else>
              <v-icon color="primary" size="30" @click="login"
                >mdi-account</v-icon
              >
            </div>
          </v-avatar>
        </template>

        <v-card>
          <v-list>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary">mdi-account-circle</v-icon>
              </v-list-item-icon>

              <!--     <v-list-item-avatar>
                <v-img
                  max-height="150"
                  max-width="250"
                  :src="getImg"
                  :lazy-src="getImg"
                  class="grey lighten-2"
                >
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="grey lighten-5"
                      ></v-progress-circular>
                    </v-row> </template
                ></v-img>
              </v-list-item-avatar> -->

              <v-list-item-content>
                <v-list-item-title>{{ this.getName }}</v-list-item-title>
                <v-list-item-subtitle>
                  <!--   <v-progress-circular
                    v-if="loadBalance == true"
                    :size="20"
                    indeterminate
                    color="primary"
                  ></v-progress-circular> -->
                </v-list-item-subtitle>
              </v-list-item-content>

              <!--   <v-list-item-action>
                      <v-btn
                        :class="fav ? 'red--text' : ''"
                        icon
                        @click="fav = !fav"
                      >
                        <v-icon>mdi-heart</v-icon>
                      </v-btn>
                    </v-list-item-action> -->
            </v-list-item>
          </v-list>

          <v-divider></v-divider>

          <v-list nav dense>
            <!--  <v-list-item link to="/bet">
               <v-list-item-icon>
                <v-icon>mdi-account-circle</v-icon>
              </v-list-item-icon> 

              <v-list-item-content>
                <v-list-item-title>Mi Perfil</v-list-item-title>
              </v-list-item-content>
            </v-list-item> 

            <v-divider></v-divider>
            -->

            <v-list-item link to="/config" v-if="getAdmin">
              <!--  <v-list-item-icon>
                <v-icon>mdi-account-box</v-icon>
              </v-list-item-icon> -->

              <v-list-item-content>
                <v-list-item-title>Configuraciones</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-divider></v-divider>
          </v-list>

          <v-card-actions class="justify-center">
            <v-btn color="red" small dark rounded @click="closeSession()">
              Cerrar Session
              <v-icon right dark>mdi-account-off</v-icon></v-btn
            >
          </v-card-actions>
        </v-card>
      </v-menu>
    </v-tab>
    <!--     <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-width="600"
      offset-x
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon class="mr-3" dark v-bind="attrs" v-on="on" @click="login">
        

          <div v-if="getActive">
            <v-icon color="primary" size="30">mdi-account-check</v-icon>
          </div>
          <div v-else>
            <v-icon color="primary" size="30">mdi-account</v-icon>
          </div>
          
        </v-btn>
      </template>
    </v-menu> -->

    <confirm ref="confirm"></confirm>
    <Alert ref="Alert"></Alert>
  </div>
</template>
<script>
import confirm from "@/components/Reusable/Confirm.vue";
import Alert from "@/components/Reusable/Alert.vue";
import Login from "@/views/Login/Login.vue";

export default {
  name: "MainViewComponent",
  components: {
    confirm,
    Alert,
    Login,
  },
  data: () => ({
    listCategory: [],
    model: false,
    switchText: "NO",
    dataEnvio: 0,
  }),
  created() {},
  watch: {
    model(value) {
      if (value === false) {
        this.switchText = "NO";
      } else {
        this.switchText = "SI";

        this.$axios
          .post("https://apiprod.starkenpro.cl/quote/caja-tarifa", {
            entrega: "DOMICILIO",
            tipoServicio: "NORMAL",
            codigoAgenciaDestino: 1345,
            codigoAgenciaOrigen: 1197,
            rutCliente: "",
            codigoTipoPago: 1,
            codigoCiudadOrigen: 1,
            codigoCiudadDestino: 19,
            rutDestinatario: "",
            encargos: [
              {
                tipoEncargo: "29",
                alto: "10",
                ancho: "7",
                largo: "6",
                kilos: "5",
              },
            ],
          })
          .then((res) => {
            this.dataEnvio = res.data;
          })
          .catch((error) => {
            console.log(error.response);
          });
      }
    },
  },
  computed: {
    getActive() {
      return this.$store.getters.getCurrentCredentials.active;
    },
    quantityCart() {
      return this.$store.getters.getCurrentCredentials.shoppingCartUser.length;
    },
    getName() {
      return this.$store.getters.getCurrentCredentials.name;
    },
    getAdmin() {
      return this.$store.getters.getCurrentCredentials.admin;
    },
    getTotalPrice() {
      if (!this.$store.getters.getCurrentCredentials.shoppingCartUser)
        this.$store.getters.getCurrentCredentials.shoppingCartUser = [];
      let totalPrice = 0;
      if (
        this.$store.getters.getCurrentCredentials.shoppingCartUser.length !== 0
      ) {
        this.$store.getters.getCurrentCredentials.shoppingCartUser.forEach(
          (el) => (totalPrice += el.quantity * el.price)
        );
      }
      this.total = totalPrice;
      return this.numberWithCommas(totalPrice);
    },
    getImg() {
      return "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTzKVthIfiYthRncPbOBr4bA1SFIdExbup_hg&usqp=CAU";
    },
  },
  methods: {
    login() {
      this.$router.push("/login");
    },
    closeSession() {
      //https://sweetalert2.github.io/
      this.$swal
        .fire({
          title: "Seguro que quiere salir?",
          text: "",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#20a8d8",
          cancelButtonColor: "#f86c6b",
          cancelButtonText: "No",
          confirmButtonText: "SI",
        })
        .then((result) => {
          if (result.value) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/principal");
              this.$toast.info("", "Sessión cerrada con éxito", 3000);
            });
          } else {
          }
        });
    },
    deleteItem(item) {
      this.$store
        .dispatch("deleteShoppingCart", item)
        .then((response) => {
          this.$store.commit("showSnackbar", {
            text: "Producto eliminado con éxito",
            color: "success",
          });
        })
        .catch((error) => {
          this.$refs.Alert.open("Error", "Problemas al realizar la operación", {
            color: "red",
          });
        });
    },
    cleanCart() {
      this.$store
        .dispatch("clearCart", "")
        .then((response) => {
          this.$store.commit("showSnackbar", {
            text: "El carrito esta vacio",
            color: "success",
          });
        })
        .catch((error) => {
          this.$refs.Alert.open("Error", "Problemas al realizar la operación", {
            color: "red",
          });
        });
    },
    numberWithCommas(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  mounted() {},
};
</script>
